import React from "react";
import { Block, Button, FieldArray, FormGroup, Input, PortletAccordionItem, TextInput } from "../../../../components";
import colors from "../../../../utils/colors";

export default function ListEducation({ value = [] }) {
    return (
        <FieldArray
            name={"education"}
            render={(arrayHelpers) => {
                return (
                    <>
                        {value.map((_item, index) => {
                            return (
                                <PortletAccordionItem
                                    key={index}
                                    title={"Education" + " #" + (index + 1)}
                                    onClickDelete={() => arrayHelpers.remove(index)}
                                    onClickMoveDown={() => arrayHelpers.move(index, index + 1)}
                                    onClickMoveUp={() => arrayHelpers.move(index, index - 1)}
                                >
                                    <FormGroup title="Course">
                                        <Block width={456}>
                                            <Input Component={TextInput} name={`education[${index}].course`} placeholder="Course of studies" />
                                        </Block>
                                    </FormGroup>
                                    <FormGroup title="Institution">
                                        <Block width={456}>
                                            <Input Component={TextInput} name={`education[${index}].institution`} placeholder="Institution of study" />
                                        </Block>
                                    </FormGroup>
                                    <FormGroup title="Conclusion">
                                        <Block width={456}>
                                            <Input Component={TextInput} name={`education[${index}].conclusion`} placeholder="Year of conclusion" />
                                        </Block>
                                    </FormGroup>
                                </PortletAccordionItem>
                            );
                        })}
                        <Block>
                            <Button width="100%" icon="plus_16px" color={colors.grey01} onClick={() => arrayHelpers.insert(value.length, {})} />
                        </Block>
                    </>
                );
            }}
        />
    );
}